import * as React from "react"
import Message, { MessageType } from "./Message"

const InfoMessage = (props: any) => (
  <Message type={MessageType.INFO}>{props.children}</Message>
)

export default InfoMessage
